export enum HelpCenterFeatureFlags {
  PSMessenger = 'PSMessenger',
  PSMessengerConfig = 'PSMessengerConfig',
  PSMessengerIgnoreLogin = 'PSMessengerIgnoreLogin',
  PSMessengerToggle = 'PSMessengerToggle',
  SFConfig = 'SFConfig',
  SFHideLoginPrompt = 'SFHideLoginPrompt',
  SFShowButton = 'SFShowButton'
}
